/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MarketListItem,
    MarketListItemFromJSON,
    MarketListItemFromJSONTyped,
    MarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarketListResponse
 */
export interface MarketListResponse {
    /**
     * 
     * @type {Array<MarketListItem>}
     * @memberof MarketListResponse
     */
    items?: Array<MarketListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketListResponse
     */
    totalRecords?: number;
}

export function MarketListResponseFromJSON(json: any): MarketListResponse {
    return MarketListResponseFromJSONTyped(json, false);
}

export function MarketListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(MarketListItemFromJSON)),
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function MarketListResponseToJSON(value?: MarketListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(MarketListItemToJSON)),
        'totalRecords': value.totalRecords,
    };
}


